import React from 'react'
import AnonymousView from '../anonymous-view'

const AnonymousViewPl = () => {
    return <AnonymousView languageCode="pl" />
}

export default AnonymousViewPl
